import { constants as c } from '../imports'
import getLocalizedTexts from '../localization'
import { setCommonTexts } from '../data'

const CommonTextsMiddleware = store => next => (action) => {
    switch (action.type) {
        // Locale has changed, get the localized text
        case c.LOCALE_CHANGED: {
            const result = next(action)
            const text = getLocalizedTexts(action.payload)
            store.dispatch(
                setCommonTexts({
                    attention: text.attention,
                    error: text.error,
                    warning: text.warning,
                    externalLink: text.externalLink,
                    errorLoginUser: text.error_loginUser,
                }),
            )
            return result
        }

        default:
            return next(action)
    }
}

export default CommonTextsMiddleware



// WEBPACK FOOTER //
// ./src/features/CommonTexts/middleware/index.js